import { useState } from 'react';

import { PayHeader } from '../PayHeader';
import { PhoneForm } from '../PhoneForm';
import { LoanForm } from '../LoanForm';
import { Tabs } from '../Tabs';

export const SearchForm = () => {
  const tabs = [
    {
      id: 'phone',
      text: 'По номеру телефона',
    },
    {
      id: 'loan',
      text: 'По номеру займа',
    },
  ];
  const [activeForm, setActiveForm] = useState('phone');

  return (
    <>
      <PayHeader title="Поиск займа для оплаты" />
      <Tabs tabs={tabs} activeTab={activeForm} setActiveTab={setActiveForm} />
      {activeForm === 'phone' ? <PhoneForm /> : <LoanForm />}
    </>
  );
};
